import { useState } from 'react';
import FormStepOne from './FormStepOne';
import { botFormInputs } from './BotInfoForm';
import FormStepTwo from './FormStepTwo';
import { Button } from 'components/ui/button';

interface BotInfoFormMobileProps {
  botInputs: botFormInputs;
  setBotInputs: React.Dispatch<React.SetStateAction<botFormInputs>>;
  isDisabled?: boolean;
  pending?: boolean;
  isAuthenticated?: boolean;
}

const BotInfoFormMobile = ({
  botInputs,
  setBotInputs,
  isDisabled,
  pending,
  isAuthenticated = false,
}: BotInfoFormMobileProps) => {
  const [currentStep, setCurrentStep] = useState(1);

  const handleContinue = () => {
    setCurrentStep(2);
  };

  if (currentStep === 1) {
    return (
      <FormStepOne
        botInputs={botInputs}
        setBotInputs={setBotInputs}
        handleContinue={handleContinue}
      />
    );
  } else {
    return (
      <FormStepTwo
        botInputs={botInputs}
        setBotInputs={setBotInputs}
        isDisabled={isDisabled || false}
        pending={pending || false}
        isAuthenticated={isAuthenticated}
      />
    );
  }
};

export default BotInfoFormMobile;
